import styled from "styled-components";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";

export const SidebarContainer = styled.aside`
  position: fixed;
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.brand.green};
  display: grid;
  align-items: center;
  top: 0;
  left: 0;
  transition: 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? "100%" : "0")};
  top: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
  z-index: 1500;
`;

export const Icon = styled.div`
  position: absolute;
  /* transform: translate(-100%, 70%); */
  top: 2rem;
  right: 2rem;
  background: transparent;
  font-size: 2.4rem;
  cursor: pointer;
  color: ${(props) => props.theme.base.white};

  &:hover {
    opacity: 60%;
    transition: 0.2s ease-in-out;
  }
`;

export const SidebarWrapper = styled.div``;

export const SidebarMenu = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 80px);
  text-align: center;

  @media screen and (max-width: 480px) {
    grid-template-rows: repeat(6, 60px);
  }
`;

export const SidebarLink = styled(Link)`
  color: ${(props) => props.theme.base.white};
  font-size: ${(props) => props.theme.fontSize[24]};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;

  opacity: 100%;
  cursor: pointer;

  &:hover {
    opacity: 60%;
    transition: 0.2s ease-in-out;
  }

  @media (min-width: 55em) {
    font-size: ${(props) => props.theme.fontSize[32]};
  }
`;

export const SidebarRouterLink = styled(NavLink)`
  color: ${(props) => props.theme.base.white};
  font-size: ${(props) => props.theme.fontSize[24]};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;

  opacity: 100%;
  cursor: pointer;

  &:hover {
    opacity: 60%;
    transition: 0.2s ease-in-out;
  }

  @media (min-width: 55em) {
    font-size: ${(props) => props.theme.fontSize[32]};
  }
`;

export const TermsButton = styled(NavLink)`
  color: ${(props) => props.theme.base.white};
  font-size: ${(props) => props.theme.fontSize[24]};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;

  opacity: 100%;
  cursor: pointer;

  &:hover {
    opacity: 60%;
    transition: 0.2s ease-in-out;
  }

  @media (min-width: 55em) {
    font-size: ${(props) => props.theme.fontSize[32]};
  }
`;

export const SignUpButton = styled.a`
  all: unset;
  padding-block: 0.5rem;
  padding-inline: 2rem;
  background: transparent;
  border: 1px solid ${(props) => props.theme.base.white};
  color: ${(props) => props.theme.base.white};
  font-size: ${(props) => props.theme.fontSize[20]};
  border-radius: 4px;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
  max-width: fit-content;
  align-self: center;
  justify-self: center;

  @media (hover: hover) and (pointer: fine) {
    &:hover,
    &:focus-within {
      transition: all 0.1s ease-in-out;
      opacity: 0.8;
    }
  }

  @media (min-width: 55em) {
    font-size: ${(props) => props.theme.fontSize[24]};
  }
`;
